import { ChakraImage, ChakraBox as Box } from "@airhelp/react-ui-components";
import { ReviewCard } from "modules/common/components";
import type { TrustpilotTestimonialCardProps } from "../TrustpilotTestimonial.d";

export const TrustpilotTestimonialMobile = ({ imageProps, review }: TrustpilotTestimonialCardProps) => (
  <Box borderRadius="xl" overflow="hidden">
    <ChakraImage {...imageProps} maxHeight="436px" objectFit="cover" />
    <ReviewCard review={review} borderColor="greyscale.100" boxShadow="alt" borderTopRadius="none" />
  </Box>
);
